import { UseQueryResult } from 'react-query';
import { useAuthQuery } from '../../common/apiUtils/queryHelper';
import { contextIdConfig, ListSitecoreContextsQueryParams } from '../config';
import { ListSitecoreContextsResponse } from '../types/types';

const { url, queryKey, scope } = contextIdConfig.get_contextids;

export const useGetListSitecoreContexts = (
  params: ListSitecoreContextsQueryParams = {},
  options?: {
    onSuccess?: (data: ListSitecoreContextsResponse) => void;
    onError?: (error: unknown) => void;
  },
): UseQueryResult<ListSitecoreContextsResponse> => {
  const { search, continuationToken, pageSize } = params;

  return useAuthQuery(
    [...queryKey, search ?? '', continuationToken ?? '', pageSize ?? ''],
    async (axiosInstance) => {
      const response = await axiosInstance?.get(
        url({ search, continuationToken, pageSize }),
      );
      return response?.data;
    },
    { onSuccess: options?.onSuccess, onError: options?.onError },
    scope,
  );
};
